import { render, staticRenderFns } from "./internal-movement-modal.component.vue?vue&type=template&id=b8d33260&scoped=true&"
import script from "./internal-movement-modal.component.vue?vue&type=script&lang=ts&"
export * from "./internal-movement-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./internal-movement-modal.component.vue?vue&type=style&index=0&id=b8d33260&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d33260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VTextField,VTextarea})
